import getPageVisitEventData from "../Amplitude/getPageVisitEventData";
import { redactAnalyticsPathname } from "./analyticsUrlRedactionConfig";
import sanitizeAnalyticsUrl from "./sanitizeAnalyticsUrl";

export default function buildAmplitudePageVisitEventData(pathname, href) {
  const pageData = getPageVisitEventData(pathname);

  if (!pageData) {
    return null;
  }

  const sanitizedUrl = sanitizeAnalyticsUrl(href);

  return {
    ...pageData,
    url: sanitizedUrl,
    page_location: sanitizedUrl,
    page_path: redactAnalyticsPathname(pathname),
    page_title: typeof document !== "undefined" ? document.title : undefined,
    page_domain:
      typeof window !== "undefined" ? window.location?.hostname : undefined
  };
}
